export default __webpack_public_path__ + "static/truelayer-bda082879516847bffb2b6389fc83090.svg";